import { Routes } from '@angular/router';
import { LoginPageComponent } from './components/login-page/login-page.component';
import { RegisterPageComponent } from './components/register-page/register-page.component';
import { RegisterPagePendingComponent } from './components/register-page-pending/register-page-pending.component';
import { HomePageComponent } from './components/home-page/home-page.component';
import { SearchPageComponent } from './components/search-page/search-page.component';
import { TitlePageComponent } from './components/title-page/title-page.component';
import { ProfilePageComponent } from './components/profile-page/profile-page.component';
import { EnabledGuard } from './Guard/enabled.guard';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { TestSearchComponent } from './components/test-search/test-search.component';
import { ContactPageComponent } from './components/contact-page/contact-page.component';
import { AdminGuard } from './Guard/admin.guard';

export const routes: Routes = [
    { path: 'login', component: LoginPageComponent,  data: {animation: 'page'},   },
    { path: 'login/:id', component: LoginPageComponent,  data: {animation: 'page'},   },
    { path: 'register', component: RegisterPageComponent,  data: {animation: 'page'},   },
    { path: 'pending-approval', component: RegisterPagePendingComponent,  data: {animation: 'page'},   },
    { path: '', component: HomePageComponent, canActivate: [EnabledGuard], data: {animation: 'page'},   },
    { path: 'search', component: SearchPageComponent, canActivate: [EnabledGuard], data: {animation: 'page'},   },
    { path: 'search/:query', component: SearchPageComponent, canActivate: [EnabledGuard], data: {animation: 'page'},   },
    { path: 'movies/:id', component: TitlePageComponent, canActivate: [EnabledGuard], data: {animation: 'page'},   },
    { path: 'movies/:id/:title?', component: TitlePageComponent, canActivate: [EnabledGuard],  data: {animation: 'page'},   },
    { path: 'profile', component: ProfilePageComponent, canActivate: [EnabledGuard], data: {animation: 'page'},   },
    { path: 'profile/:id', component: ProfilePageComponent, canActivate: [EnabledGuard], data: {animation: 'page'},   },
    { path: 'dashboard', component: DashboardComponent, canActivate: [AdminGuard], data: {animation: 'page'},   },
    { path: 'dashboard/:id', component: DashboardComponent, canActivate: [AdminGuard], data: {animation: 'page'},   },
    { path: 'dashboard/:id/:subSection', component: DashboardComponent, canActivate: [AdminGuard], data: {animation: 'page'},   },
    { path: 'contact', component: ContactPageComponent, data: {animation: 'page'},   },
    
    // { path: 'testsearch', component: TestSearchComponent, canActivate: [EnabledGuard], data: {animation: 'page'},   },

];
